<template>
  <v-container
    fluid
    class="mt-6 mx-7"
  >
    <validation-observer
      ref="observer"
      v-slot="{ invalid }"
    >
      <base-material-card
        inline
        icon="mdi-account-cog"
        color="primary"        
        class="ml-0 px-5 py-4"
      >
        <template v-slot:after-heading>
          <div class="display-2 font-weight-light">
            {{ title }}
          </div>
        </template>
        <v-row>
          <v-col
            cols="12"
            class="pt-0"
          >
            <validation-provider
              v-slot="{ errors }"
              rules="required"
            >
              <v-text-field
                v-model="titulo"
                class="mb-0 mt-9"
                label="Título*"
                outlined
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-stepper
              v-model="step"
              vertical
              shaped
            >
              <v-stepper-step
                :complete="step > 1"
                step="1"
                editable
              >
                Bases de Dados
                <small>Gerencia as bases de dados liberadas na ferramenta de relatórios</small>
              </v-stepper-step>
              <v-stepper-content step="1">
                <content-first-tab
                  v-model="basesLiberadasSelecionadas"
                  :bases-liberadas="basesLiberadas"
                  :max-height="maxHeightContent"
                />
                <div class="pb-2">
                  <v-btn
                    color="primary"
                    @click="step = 2"
                  >
                    <v-icon dark>
                      mdi-arrow-down
                    </v-icon>
                  </v-btn>
                </div>
              </v-stepper-content>
              <v-stepper-step
                :complete="step > 2"
                step="2"
                editable
              >
                Testes de Conformidades de Obras
                <small>Gerencia os testes de conformidades liberados</small>
              </v-stepper-step>
              <v-stepper-content step="2">
                <content-second-tab
                  v-model="testesConformidadesObrasSelecionados"
                  :max-height="maxHeightContent"
                  :testes-conformidades-obras="testesConformidadesObras"
                />
                <div class="pb-2">
                  <v-btn
                    color="primary"
                    @click="step = 3"
                  >
                    <v-icon dark>
                      mdi-arrow-down
                    </v-icon>
                  </v-btn>
                  <v-btn
                    color="gray"
                    @click="step = 1"
                  >
                    <v-icon dark>
                      mdi-arrow-up
                    </v-icon>
                  </v-btn>
                </div>
              </v-stepper-content>
              <v-stepper-step
                :complete="step > 3"
                step="3"
                editable
              >
                Ferramentas
                <small>Gerencia as ferramentas liberadas</small>
              </v-stepper-step>
              <v-stepper-content step="3">
                <content-third-tab
                  v-model="ferramentasSelecionadas"
                  :max-height="maxHeightContent"
                  :ferramentas="ferramentas"
                />
                <div class="pb-2">
                  <v-btn
                    color="gray"
                    @click="step = 2"
                  >
                    <v-icon dark>
                      mdi-arrow-up
                    </v-icon>
                  </v-btn>
                </div>
              </v-stepper-content>
            </v-stepper>
          </v-col>
        </v-row>
        <v-row>
          <v-col />
          <v-col
            cols="12"
            md="6"
          >
            <v-btn
              color="success"
              min-width="100"
              style="float: right"
              class="mr-0 mt-5"
              :disabled="invalid"
              :loading="loading"
              @click="salvar()"
            >
              Salvar
            </v-btn>
          </v-col>
        </v-row>
      </base-material-card>
    </validation-observer>
  </v-container>
</template>
<script>
import PerfisService from '@/services/PerfisService';

export default {
  components: {
    ContentFirstTab:  () => import('@/components/perfis/tabs/ContentFirstTab.vue'),
    ContentSecondTab: () => import('@/components/perfis/tabs/ContentSecondTab.vue'),
    ContentThirdTab:  () => import('@/components/perfis/tabs/ContentThirdTab.vue')
  },

  data: () => ({
    titulo: '',
    step: 1,
    maxHeightContent: 600,
    basesLiberadas: [],
    basesLiberadasSelecionadas: [],
    testesConformidadesObras: [],
    testesConformidadesObrasSelecionados: [],
    ferramentas: [],
    ferramentasSelecionadas: [],
    loading: false
  }),

  computed: {
    title() {
      return this.$route.params.id ? 'Editando Perfil de Usuário' : 'Adicionar Novo Perfil de Usuário';
    }
  },

  mounted() {
    this.getModulosPerfis();
  },

  methods: {
    getModulosPerfis() {
      this.loading = true;

      PerfisService.getModulosPerfis(this.$route.params.id ?? null)
        .then(response => {
          const rData = response.data;
          this.basesLiberadas = rData.basesLiberadas;
          this.testesConformidadesObras = rData.conformidadesTestes;
          this.ferramentas = rData.ferramentas;

          if (this.$route.params.id) {
            this.titulo = rData.perfil.perfil;
            this.basesLiberadasSelecionadas = rData.perfil.tabelas;
            this.testesConformidadesObrasSelecionados = rData.perfil.conformidades_obras_testes;
            this.ferramentasSelecionadas = rData.perfil.ferramentas;
          }
        })
        .catch (error => {
          console.error(error);
          this.$toast.error('Erro ao recuperar perfis de usuários.', '', {position:'topRight'});
        }) 
        .finally(() => this.loading = false);
    },

    salvar() {
      const data = {
        id: this.$route.params.id ? this.$route.params.id : null,
        perfil: this.titulo,
        tabelas: {_ids: this.basesLiberadasSelecionadas.map((tabela => {
          return tabela.id;
        }))},
        conformidades_obras_testes: {_ids: this.testesConformidadesObrasSelecionados.map((conformidade => {
          return conformidade.id;
        }))},
        ferramentas: {_ids: this.ferramentasSelecionadas.map((pagina => {
          return pagina.id;
        }))}
      };

      this.loading = true;
    
      PerfisService.salvar(data).then(() => {
        this.$toast.success('Perfil salvo com sucesso.', '', {position:'topRight'});
        this.$router.push({ name: 'Perfis' });
      })
        .catch(error => {
          console.error(error);
          this.$toast.error('Erro ao salvar perfil.', '', {position:'topRight'});
        })
        .finally(() => this.loading = false);
    }
  }
};
</script>